import React from 'react';
import { Link } from 'dva/router';
import { Divider } from 'antd';
import LinesEllipsis from 'react-lines-ellipsis';
import { Row, Col } from 'antd';
import styles from './rec_c.css';
class RecC extends React.Component {
    seconds2YYYYMMDD(secondS) {
        const date = new Date(Number(secondS) * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    render() {
        console.log("RecC", this.props);
        const content = this.props.data.map((item) => {
            const { pic, novel_id, name, cata, author, brief, p_num, p_time, } = item;
            const dateStr = this.seconds2YYYYMMDD(p_time);
            return <Link to={`/book/detail/${novel_id}`} key={novel_id}>
                <div className={styles.wrap_content_item}>
                    <div style={{ height: '270px', width: '212px', overflow: "hidden", position: 'relative' }}>
                        <img alt='' src={pic} className={styles.hover_img} />
                        <img alt='' src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ position: 'absolute', left: '0', top: '0', width: '100px' }} />
                    </div>
                    <div style={{ fontSize: '16px', lineHeight: '22px', color: '#333333', margin: '10px 0 10px 0', textAlign: 'left' }}>
                        <LinesEllipsis maxLine={1} text={name} title={name} />
                    </div>
                    <div style={{ fontSize: '14px', lineHeight: '20px', color: '#999999', margin: '0 0 10px 0', textAlign: 'left' }}>
                        {author && <span>{author}</span>}
                    </div>
                    {
                        /* 更新到 第x章 */
                        <div style={{ fontSize: '14px', lineHeight: '20px', color: '#333333', textAlign: 'left' }}>
                            更新到 第{p_num}章
                        </div>
                    }
                    {
                        /* 更新时间 xx-xx-xx */
                        <div style={{ fontSize: '14px', lineHeight: '20px', color: '#333333', textAlign: 'left' }}>
                            更新时间 {dateStr}
                        </div>
                    }
                </div>
            </Link>;
        })
        return (
            <div className={styles.wrap}>
                <h3>&gt;&gt;最新更新！</h3>
                <Row type="flex" justify="flex-start">
                    {content}
                </Row>
            </div>
        )
    }
}

export default RecC;


// WEBPACK FOOTER //
// ./src/component/rec/rec_c.js